'use client';

import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label='Scroll to top'
      className={`fixed bottom-8 right-8 z-50 flex size-12 items-center justify-center rounded-full bg-brand-forest text-white shadow-lg shadow-brand-forest/20 transition-all duration-300 ease-out hover:scale-110 hover:bg-brand-dark hover:shadow-xl hover:shadow-brand-forest/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-forest focus-visible:ring-offset-2 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'} `}
    >
      <ArrowUp className='size-5' />
    </button>
  );
}

export default ScrollToTop;
